var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidStarBlackHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 4.31314L7.89715 3.71671L6.06271 0L4.22826 3.71804L0.125 4.31314L3.09385 7.20694L2.39381 11.2936L6.06271 9.36484L9.7316 11.2936L9.03156 7.20694L12.0004 4.31314ZM9.37029 10.7941L6.19023 9.12242H5.93651L2.75645 10.7941L3.3635 7.25343L3.2858 7.01168L0.712792 4.50442L4.26147 3.98836L4.46736 3.83959L6.06271 0.617017L7.65274 3.83826L7.85863 3.98703L11.4073 4.50309L8.83961 7.01168L8.76058 7.25343L9.36962 10.7941H9.37029Z",
    fill: "#3268C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26692 3.98696L0.710938 4.50435L3.28394 7.0116L3.36165 7.25336L2.75393 10.7954L5.93466 9.12301H6.06152V0.616943L4.47149 3.83818L4.26692 3.98696Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidStarBlackHalf);
export default __webpack_public_path__ + "static/media/kid_starBlackHalf.a3d1d5fd2233fbb0288143e21b190d3e.svg";
export { ForwardRef as ReactComponent };